import i18n from 'shared/lib/i18n';

export const getCourierErrorTypes = () => [
  { label: i18n.t('courier.packageOutsideRoom') },
  { label: i18n.t('courier.packageOutsideBuilding') },
  { label: i18n.t('courier.incorrectInfo') },
  { label: i18n.t('common.other') },
];
